import { render, staticRenderFns } from "./HumanResourcesDashboard.vue?vue&type=template&id=5e0d59ac&scoped=true"
import script from "./HumanResourcesDashboard.vue?vue&type=script&lang=js"
export * from "./HumanResourcesDashboard.vue?vue&type=script&lang=js"
import style0 from "./HumanResourcesDashboard.vue?vue&type=style&index=0&id=5e0d59ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d59ac",
  null
  
)

export default component.exports